import React from "react";
import MainImage from "../../AuthContainer/main-image1.png";
import "./LeftContainer.scss";
import SignInTextContainer from "./SignInTextContainer";

const LeftContainer = () => {
    return (
        // <div>LeftContainer</div>
        <div className="auth__left-wrap">
            {/* <div className="main-text">
                <p className="main__para">A powerful</p>
                <p className="sub__main">social media suite</p>
                <p className="secondary__text">that helps you listen, monitor and respond to online conversations easily.</p>
            </div> */}
            <SignInTextContainer companyForm={true} />
            <div className="signin__image">
                <img src={MainImage} />
            </div>
            <p className="description__text">Radarr helps 1000+ brands globally get actionable insights</p>
            <div className="company-logos">
                <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/discovery-networks-logo.png" alt="Discovery" />
                <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/twitter-logo.png" alt="Twitter" />
                <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/glico-logo.png" alt="Glico" />
                <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/quantum-logo.png" alt="Quantum" />
                <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/toyota-logo-1.png" alt="Toyota" />
                <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/hong-leong-bank-logo.png" alt="Toyota" />
                <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/mapletree-logo.png" alt="Mapletree" />
            </div>
        </div>
    );
};

export default LeftContainer;
